import { PlanTypeValue } from './view';

export default PlanTypeValue;
